import React, { useId } from 'react';

import Icon from '~/src/common/components/Icon';

import ErrorMessage from '../ErrorMessage';

import { Container, Label, ValidationIndicator, InputRow, InputRowChildren } from './layout';

interface Props {
  label?: React.ReactNode;
  hasError?: boolean;
  showIndicator?: boolean;
  error?: string;
  id?: string;
  children: React.ReactElement;
  subChild?: React.ReactNode;
}

const InputContainer = ({
  label,
  hasError,
  showIndicator,
  error,
  children,
  id,
  subChild,
  ...props
}: Props) => {
  const reactId = useId();
  const uniqueId = id ?? reactId;
  const isInvalid = hasError ?? error != null;

  return (
    <Container {...props}>
      {label != null ? <Label htmlFor={uniqueId}>{label}</Label> : null}
      {subChild ?? null}
      <InputRow>
        <InputRowChildren $hasError={isInvalid} $showIndicator={showIndicator}>
          {React.cloneElement(children, { id: uniqueId })}
        </InputRowChildren>
        {showIndicator ? (
          <ValidationIndicator aria-label={`${uniqueId}-${isInvalid ? 'error' : 'valid'}`}>
            <Icon name={isInvalid ? 'warning-normal' : 'valid-small'} size={24} />
          </ValidationIndicator>
        ) : null}
      </InputRow>
      {error != null ? <ErrorMessage>{error}</ErrorMessage> : null}
    </Container>
  );
};

export default InputContainer;
